import { Link } from '@mui/material';
import React from 'react';

export const EmailNeonSales = () => {
    return <Link href="mailto:neonsales@marex.com">neonsales@marex.com</Link>;
};
